import { message, Modal, Spin } from 'antd';
import { downloadCSV } from 'components/Download/useDownloadForm'
import { useState } from 'react';
import { disburseLoans } from 'services/AdminUserService';



export default function DownloadCSVBtn({ data, fileName = "accepted_loans",title="Download CSV",showStatus=true }) {
    const [loading, setLoading] = useState(false);

    const handleDownloadCSV = async () => {
        try {
            await downloadCSV(data, fileName,showStatus)
        } finally {
            setLoading(false);
        }
    }

    return (
        <button onClick={handleDownloadCSV} disabled={loading} className="bg-gray-200 text-[#333333] border disabled:opacity-60 border-gray-500 px-4 flex gap-2 font-medium rounded-md py-2">
            {loading ? <Spin /> : (
                <>
                    <span><i className="bi bi-download"></i></span>
                    <span>{title} ({data.length})</span>
                </>
            )}
        </button>
    )
}
export function DisburseBtn({ data,refetch }) {
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false)

    const selectedLoans = data

    const closeModal = () => {
        setOpen(false)
    }
    const openModal = () => {
        if (data.length === 0) {
            message.warning("Please select atleast one loan for disbursement")
            return;
        }
        setOpen(true)
    }
    const handleSubmit = async () => {
        if (data.length === 0) {
            message.warning("Please select atleast one loan for disbursement")
            return;
        }
        setLoading(true)
        const res = await disburseLoans({ selectedLoans })
        setOpen(false)
        if (!res.error) {
            message.success("Loans added as disbursed Loans successfully")
        }
        closeModal()
        refetch()

    }
    return (
        <>
            <Modal open={open} footer={null} maskClosable={false} closeIcon={null} centered>
                <div className="text-center">
                    <h3 className="text-2xl font-semibold text-primary py-2 border-b">Confirm Disbursement</h3>
                    <p className="text-lg my-6">Are you sure you want to confirm these {data.length} name(s) as disbursed loans. This action cannot be reversed</p>
                    <footer className="flex justify-center items-center gap-4 w-full">
                        <button onClick={closeModal} className="text-lg font-medium bg-red-200 rounded-md text-red-800 px-8 py-2">Cancel</button>
                        <button disabled={loading} onClick={handleSubmit} className="text-lg disabled:opacity-50 disabled:cursor-not-allowed font-medium px-8 py-2 rounded-md bg-primary-200 text-primary-800">
                            {loading ? (
                                <Spin />
                            ) : "Continue"}
                        </button>

                    </footer>
                </div>
            </Modal>

            <button onClick={openModal} className="bg-primary px-6 disabled:opacity-40 disabled:cursor-not-allowed py-2 rounded-md text-white" disabled={selectedLoans.length === 0}>
                <span>Disburse Selected ({data.length})</span>
            </button>
        </>

    )
}